import { find } from "lodash-es";
import { Header } from "ui";

import { useGlobalStore } from "@/store";

const ROLE_KEY = "role";
export const DeskHeader = () => {
  const { roles } = useGlobalStore();
  const toAdmin = () => {
    const newPage = window.open("/admin", "_blank");
    newPage?.sessionStorage.clear();
  };
  const adminOption = () => {
    return find(roles, ({ role }) => ["SystemManager", "TenantManager"].includes(role))
      ? {
        key: "admin",
        label: "Admin 管理",
        onClick: toAdmin,
      }
      : null;
  };
  return <Header rightOperation={[adminOption()]} />;
};
